import { Helmet } from 'react-helmet-async';

export default function TransitionsUsers() {
    return (
        <>
            <Helmet>
                <title>Transition Users | Platform Solutions</title>
            </Helmet>
            <h1>Users</h1>
        </>
    );
}